import { Theme } from "@forms/schema";
import dayjs, { Dayjs } from "dayjs";

export type TSurveySlug = "survey-demographic";

export type TSurvey = "DEMOGRAPHIC" | "WEIGHT" | "DENTAL" | "GASTROINTESTINAL" | "JOINTS";

export interface ISurveyDetail {
  key: TSurvey;
  title: string;
  description: string;
  image: {
    src: string;
    width: number;
    height: number;
  };
  link?: string;
  starts?: Dayjs;
  closes?: Dayjs;
  theme?: Theme;
  blockedBy?: TSurvey[];
  timeToComplete?: {
    hours?: number;
    minutes?: number;
  };
  linkText?: string;
}

export const SURVEY_LAST_QUESTION_MAP: Record<TSurveySlug, string> = {
  "survey-demographic": "face_shape",
};

export const SURVEY_MAP: Record<TSurveySlug, TSurvey> = {
  "survey-demographic": "DEMOGRAPHIC",
};

export const SURVEYS: ISurveyDetail[] = [
  {
    key: "DEMOGRAPHIC",
    title: "The Basics",
    description: "Start with this survey to give us more information about your cat - who they are and what they’re like!",
    image: {
      src: "/images/surveys/preview-demographics.webp",
      width: 580,
      height: 520,
    },
    link: "/surveys/health/demographic/start",
    starts: dayjs("2024-11-11"),
    blockedBy: [],
    timeToComplete: {
      minutes: 2,
    },
  },
  {
    key: "WEIGHT",
    title: "Weight",
    description: "Discover how your cat’s weight compares to their ideal, and get tips on how to effectively manage their weight",
    image: {
      src: "/images/surveys/preview-weight.webp",
      width: 580,
      height: 520,
    },
    link: "/surveys/health/weight/start",
    starts: dayjs("2024-11-11"),
    blockedBy: [ "DEMOGRAPHIC" ],
    timeToComplete: {
      minutes: 3,
    },
  },
  {
    key: "DENTAL",
    title: "Dental",
    description: "Dental issues can crop up at any time. Take this survey to understand if your cat is predisposed to dental issues",
    image: {
      src: "/images/surveys/preview-dental.webp",
      width: 580,
      height: 520,
    },
    starts: dayjs("2025-11-11"),
    blockedBy: [ "DEMOGRAPHIC" ],
  },
  {
    key: "GASTROINTESTINAL",
    title: "Gastrointestinal",
    description: "Similarly to humans, gut health is important in cats. See what you can do to maintain - or improve - your cat’s gut health",
    image: {
      src: "/images/surveys/preview-gastro.webp",
      width: 580,
      height: 520,
    },
    starts: dayjs("2025-11-11"),
    blockedBy: [ "DEMOGRAPHIC" ],
  },
  {
    key: "JOINTS",
    title: "Joints",
    description: "Senior cats may struggle with reduced mobility. Pre-empt issues they might face by taking this survey",
    image: {
      src: "/images/surveys/preview-joints.webp",
      width: 580,
      height: 520,
    },
    starts: dayjs("2025-11-11"),
    blockedBy: [ "DEMOGRAPHIC" ],
  },
];
